import { View, Text } from "@react-pdf/renderer";
import { RegisterFont } from "./InvoiceBill";
import { BillStylesA4 as styles } from "./BillStyle";
import { GetPatientAge, GetPatientSex } from "../../core/Helper2";
import { ConvertDateFromSQL } from "../../core/ThaiDate";
import BuildDocument, { GetDocuHeaderSection } from "./DocumentSections";

export const GetDocuCustomerAppoint = async ({ printInfo }) => {
  const { Patient, BranchRight, CustSender, Physician, Good } = printInfo;
  // console.log(Study);
  return (
    <View>
      <View style={styles.horizonView}>
        <View style={styles.customerDetailBox}>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>ชื่อคนไข้: </Text>
            <Text style={styles.textValue}>{Patient?.PatientFullName} </Text>
          </View>

          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>เลขที่บัตร: </Text>
            <Text style={styles.textValue}>{Patient?.IdCardNo} </Text>
          </View>

          <View style={{ ...styles.horizonView, justifyContent: "flex-start" }}>
            <View style={styles.horizonView}>
              <Text style={styles.textLabel}>อายุ: </Text>
              <Text style={styles.textValueNoFlex}>
                {GetPatientAge(Patient?.PatientsAge ?? " ปั")}
              </Text>
            </View>
            <View style={styles.horizonView}>
              <Text style={styles.textLabel}>เพศ: </Text>
              <Text style={styles.textValueNoFlex}>
                {GetPatientSex(Patient?.PatientsSex)}
              </Text>
            </View>
          </View>
          <View style={styles.horizonView}>
            <View style={styles.horizonView}>
              <Text style={styles.textLabel}>สิทธิการรักษา: </Text>
              <Text style={styles.textValue}>{BranchRight?.BrchRightName}</Text>
            </View>
          </View>
        </View>

        {/*  */}
        <View style={styles.customerDetailBox}>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>วัน-เวลานัดตรวจ:</Text>
            <Text style={styles.textValue}>
              {ConvertDateFromSQL(printInfo?.AppointmentDate)}
            </Text>
          </View>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>ประเภทการตรวจ:</Text>
            <Text style={styles.textValue}>{Good?.Modality?.GoodModName}</Text>
          </View>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>ส่วนที่ตรวจ:</Text>
            <Text style={styles.textValue}>{Good?.GoodName}</Text>
          </View>
        </View>

        {/*  */}
      </View>

      {/* <View style={styles.drawLine}></View> */}
      {/*  */}
      <View style={styles.horizonView}>
        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>รพ/คลินิก: </Text>
          <Text style={styles.textValue}>
            {CustSender?.CustShortName + " "}
          </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>HN: </Text>
          <Text style={styles.textValue}>{} </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>วอร์ด: </Text>
          <Text style={styles.textValue}>{} </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>แพทย์ส่ง: </Text>
          <Text style={styles.textValue}>{Physician?.FullName}</Text>
        </View>
      </View>
    </View>
  );
};

const getText = (text) => {
  return <Text style={styles.textVerySmall}>{text}</Text>;
};

export const BuildAppointPDF = async ([pdf, setPdf, data]) => {
  RegisterFont();

  if (!data) {
    alert("No branch found!");
    return;
  }

  console.log(data);

  let modality = data?.Good?.Modality?.GoodModName ?? "CT";
  console.log("GoodModName", modality);

  let prepareText = <View></View>;
  switch (modality?.toUpperCase()) {
    case "CT":
      prepareText = await CTPrepareMessage();
      break;
    case "MRI":
      prepareText = await MRIPrepareMessage();
      break;
    default:
      prepareText = await CTPrepareMessage();
      break;
  }

  setPdf(
    <BuildDocument
      {...{
        docHeader: await GetDocuHeaderSection({ printInfo: data }),
        customer: await GetDocuCustomerAppoint({ printInfo: data }),
        items: prepareText,
      }}
    />
  );
};

export const MRIPrepareMessage = async () => {
  return (
    <View>
      <Text style={styles.p1Underline}>การเตรียมตัวก่อน MRI</Text>

      {getText(" เจาะเลือดดูการทำงานของไต (BUN/Cr/eGFR.) ** ไม่ควรเกิน 30 วัน")}
      {getText(
        "งดน้ำและอาหาร หลังเวลา.................................................ของวันที่............................................." +
          "กรณีฉีด Gadovist งดน้ำและอาหาร 4 ชั่วโมง"
      )}

      {getText(
        "ตรวจ ABDDOMAN/MRCP/MRA/MRI RENAL ARTERY งดน้ำและอาหาร 6- 8 ชั่วโมง"
      )}

      <Text style={styles.p1Underline}>ข้อห้ามและคำแนะนำที่ควรปฏิบัติ</Text>
      {getText(
        "1.ห้ามแต่งหน้า /ห้ามใส่เหล็กจัดฟัน ( กรณีตรวจส่วนศีรษะและส่วนคอ Brain and C-Spine ) โลหะหรืออุปกรณ์ ที่สามารถถอดได้ให้ถอดออก เช่น ฟันปลอม กิ๊บผม เข็มกลัด บัตรต่าง โทรศัพท์มือถือ เป็นต้น หากสงสัยว่าตั้งครรภ์โปรดแจ้งเจ้าหน้าที่"
      )}

      <Text>หมายเหตุ</Text>
      {getText(
        "2. ผู้ป่วยชำระเงินเอง , เบิกได้สำรองจ่าย กรุณาเตรียมเงินค่าตรวจมาด้วย"
      )}
      {getText("2. ถ้าต้องการเลื่อนนัด กรุณาโทรเบอร์แจ้งก่อนถึงวันนัด 2 วัน")}
      {getText(
        "3. หากท่านมาเลยเวลาที่นัดไว้ โปรดรอจนกว่าจะมีคิวว่างหรืออาจจำเป็นต้องเลื่อนนัด"
      )}
      {getText(
        "4. เวลาในการตรวจแต่ละครั้งอาจมีความคลาดเคลื่อน เนื่องจากผู้ป่วยแต่ละท่านให้ความร่วมมือไม่เท่ากันหรือมีเหตุขัดข้องจากตัวเครื่องเอง"
      )}
      {getText("5. หากมี Film เก่าหรือ CD กรุณานำมาด้วยทุกครั้งด้วยนะคะ")}

      <Text style={styles.p1Underline}>
        การเตรียมตัวสำหรับผู้ป่วยที่มารับการตรวจด้วยเครื่องสร้างภาพด้วยสนามแม่เหล็กไฟฟ้า
        (MRI)
      </Text>
      {getText(
        "1. เนื่องจากเป็นการตรวจที่ไม่เจ็บปวด ท่านเพียงแต่ทำ ใจให้สงบ นอนนิ่งๆ " +
          " ไม่ต้องกลัวใช้เวลาประมาณ 30-40 นาที กรณีที่ไม่มีการฉีด contrast " +
          "แต่ถ้ามีการฉีด contrast จะใช้การตรวจประมาณ 1ชั่วโมงเป็นอย่างต่ำ "
      )}

      {getText("2. ในขณะที่เครื่องทำงานจะมีเสียงดัง กรุณาอย่าตกใจ!")}
      {getText(
        "3. ในขณะที่ท่านทำ การตรวจอยู่ในเครื่อง " +
          "จะมีเจ้าหน้าที่ดูแลท่านอยู่ตลอดเวลา ถ้ามีปัญหาขัดข้องอะไร ท่าน " +
          "สามารถบีบลูกบอลยางที่อยู่ภายในเครื่องได้ "
      )}
      {getText(
        "4. เนื่องจากเป็นการตรวจที่ละเอียด จึงใช้เวลาค่อนข้างนาน " +
          "ประมาณในการตรวจแต่ละชุดท่านต้องนอนให้นิ่งที่สุด" +
          " ไม่เช่นนั้นจะทำให้ภาพไหวและไม่ชัดเจน อาจทำ ให้การวินิจฉัยไม่แม่นยำ"
      )}

      {getText(
        "  5. เจ้าหน้าที่จะทำ" +
          "การอธิบายอีกครั้งก่อนเข้ารับการตรวจหากมีข้อสงสัยให้สอบถามเจ้าหน้าที่ได้"
      )}

      {getText(
        "6.ถ้าท่านเกิดการกังวลใจหรือกลัวที่จะอยู่คนเดียวในห้องหรือกลัวที่แคบ    โปรดแจ้งเจ้าหน้าที่ก่อนเข้ารับการตรวจ" +
          "ซึ่งอาจให้ญาตินั่งเป็นเพื่อนได้โดยไม่มีอันตรายใด ๆ"
      )}

      <Text style={styles.p1Underline}>ข้อควรระวังในการตรวจ MRI</Text>

      {getText(
        "เนื่องจากเครื่องตรวจ MRI มีสนามแม่เหล็กแรงสูงตลอดเวลา ทำให้มีผลต่อการทำงานของอุปกรณ์ที่มีส่วนผสมของโลหะทั้งที่อยู่ร่างกาย หรือที่ติดมากับผู้ป่วย ดังนั้น ผู้ป่วยต้องแจ้งให้เจ้าหน้าที่ผู้เกี่ยวข้องทราบ ในกรณีต่อไปนี้"
      )}
      {getText(
        "1. การผ่าตัดใส่เครื่องกระตุ้นการเต้นของหัวใจ (Cardiac pacemaker)"
      )}
      {getText(
        "2. การผ่าตัดติดคลิปอุดหลอดเลือดในเส้นเลือดโป่งพอง (Aneurysm clips)"
      )}
      {getText("3. ผู้ป่วยที่ต้องเปลี่ยนลิ้นหัวใจเทียมชนิดโลหะ")}
      {getText("4. การผ่าตัดใส่อวัยวะเทียมภายในหู (Ear implant)")}
      {getText(
        "5. มีโลหะต่าง ๆ อยู่ในร่างกาย เช่น ข้อเทียมต่าง ๆ โลหะดามกระดูก กระสุนปืน เป็นต้น"
      )}
      {getText("6. การตั้งครรภ์โดยเฉพาะในระยะ 3 เดือนแรก")}
      {getText("7. มีสิ่งแปลกปลอมที่เป็นโลหะติดอยู่ที่ตา")}
      {getText("8. กลัวที่แคบ หรือไม่สามารถนอนราบในอุโมงค์ตรวจได้")}
      {getText(
        "9. หลีกเลี่ยงการแต่งหน้า เนื่องจากเครื่องสำอางบางชนิดทำ ให้เกิดภาพบิดเบี้ยวไป (distortion)"
      )}
    </View>
  );
};

export const CTPrepareMessage = async () => {
  return (
    <View>
      <Text style={styles.p1Underline}>การเตรียมตัวก่อน CT</Text>

      {getText(" เจาะเลือดดูการทำงานของไต (BUN/Cr/eGFR.) ** ไม่ควรเกิน 30 วัน")}
      {getText(
        "งดน้ำและอาหาร หลังเวลา.................................................ของวันที่............................................." +
          "กรณีฉีด Gadovist งดน้ำและอาหาร 4 ชั่วโมง"
      )}

      {getText(
        "ตรวจ ABDDOMAN/MRCP/CTA/CT RENAL ARTERY งดน้ำและอาหาร 6- 8 ชั่วโมง"
      )}

      <Text style={styles.p1Underline}>ข้อห้ามและคำแนะนำที่ควรปฏิบัติ</Text>
      {getText(
        "1.ห้ามแต่งหน้า /ห้ามใส่เหล็กจัดฟัน ( กรณีตรวจส่วนศีรษะและส่วนคอ Brain and C-Spine ) โลหะหรืออุปกรณ์ ที่สามารถถอดได้ให้ถอดออก เช่น ฟันปลอม กิ๊บผม เข็มกลัด บัตรต่าง โทรศัพท์มือถือ เป็นต้น หากสงสัยว่าตั้งครรภ์โปรดแจ้งเจ้าหน้าที่"
      )}

      <Text>หมายเหตุ</Text>
      {getText(
        "2. ผู้ป่วยชำระเงินเอง , เบิกได้สำรองจ่าย กรุณาเตรียมเงินค่าตรวจมาด้วย"
      )}
      {getText("2. ถ้าต้องการเลื่อนนัด กรุณาโทรเบอร์แจ้งก่อนถึงวันนัด 2 วัน")}
      {getText(
        "3. หากท่านมาเลยเวลาที่นัดไว้ โปรดรอจนกว่าจะมีคิวว่างหรืออาจจำเป็นต้องเลื่อนนัด"
      )}
      {getText(
        "4. เวลาในการตรวจแต่ละครั้งอาจมีความคลาดเคลื่อน เนื่องจากผู้ป่วยแต่ละท่านให้ความร่วมมือไม่เท่ากันหรือมีเหตุขัดข้องจากตัวเครื่องเอง"
      )}
      {getText("5. หากมี Film เก่าหรือ CD กรุณานำมาด้วยทุกครั้งด้วยนะคะ")}

      <Text style={styles.p1Underline}>
        การเตรียมตัวสำหรับผู้ป่วยที่มารับการตรวจเอกซเรย์คอมพิวเตอร์ (CT-Scan)
      </Text>
      {getText(
        "1. เนื่องจากเป็นการตรวจที่ไม่เจ็บปวด ท่านเพียงแต่ทำ ใจให้สงบ นอนนิ่งๆ " +
          " ไม่ต้องกลัวใช้เวลาประมาณ 30-40 นาที กรณีที่ไม่มีการฉีด contrast " +
          "แต่ถ้ามีการฉีด contrast จะใช้การตรวจประมาณ 1ชั่วโมงเป็นอย่างต่ำ "
      )}

      {getText(
        "2. เนื่องจากเป็นการตรวจที่ละเอียด จึงใช้เวลาค่อนข้างนาน " +
          "ประมาณในการตรวจแต่ละชุดท่านต้องนอนให้นิ่งที่สุด" +
          " ไม่เช่นนั้นจะทำให้ภาพไหวและไม่ชัดเจน อาจทำ ให้การวินิจฉัยไม่แม่นยำ"
      )}

      {getText(
        "3. เจ้าหน้าที่จะทำ" +
          "การอธิบายอีกครั้งก่อนเข้ารับการตรวจหากมีข้อสงสัยให้สอบถามเจ้าหน้าที่ได้"
      )}

      {getText(
        "4.ถ้าท่านเกิดการกังวลใจหรือกลัวที่จะอยู่คนเดียวในห้องหรือกลัวที่แคบ    โปรดแจ้งเจ้าหน้าที่ก่อนเข้ารับการตรวจ" +
          "ซึ่งอาจให้ญาตินั่งเป็นเพื่อนได้โดยไม่มีอันตรายใด ๆ"
      )}

      {/* <Text style={styles.p1Underline}>ข้อควรระวังในการตรวจ CT</Text> */}
    </View>
  );
};
